<template>
  <div class="h-full flex relative">
    <el-card class="h-full mr-10px w-300px" :body-style="{ height: '100%' }">
      <div class="flex items-center">
        <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">目录树</span>
        <el-dropdown>
          <span class="el-dropdown-link">
            <i
              class="iconfont icon-line-moreVertical text-14px font-bold text-hex-$contentTextColor"
            ></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="operateTree(true)">展开全部</el-dropdown-item>
            <el-dropdown-item @click.native="operateTree(false)">收起全部</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="flex mt-10px mb-10px">
        <el-input
          clearable
          placeholder="名称"
          class="flex-1 mr-10px"
          v-model="treeKeyword"
          prefix-icon="el-icon-search"
        />
        <el-button
          size="small"
          type="primary"
          @click="$refs.modelTreeTree.filter(treeKeyword)"
        >
          搜索
        </el-button>
      </div>
      <el-tree
        v-if="treeStandBy"
        ref="modelTreeTree"
        :default-expand-all="defaultExpandAll"
        :data="treeData"
        class="h-[calc(100%-84px)] overflow-auto"
        :props="{
          children: 'child',
          label: 'name',
        }"
        highlight-current
        node-key="id"
        :expand-on-click-node="true"
        :filter-node-method="filterTree"
        :default-expanded-keys="defaultExpandIds"
        :current-node-key="currentNodeKey"
        @node-click="handleNodeClick"
        v-loading="treeLoading"
      >
      </el-tree>
    </el-card>
    <el-card class="h-full flex-1" :body-style="{ height: '100%' }">
      <div class="flex items-center">
        <el-input
          v-model="search.name"
          size="small"
          placeholder="采集名称"
          class="w-180px mr-10px"
          clearable
        ></el-input>
        <el-select
          size="small"
          v-model="search.isEnable"
          placeholder="是否启用"
          clearable
          class="w-180px mr-10px"
        >
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>
        <div>
          <el-button
            type="primary"
            size="small"
            @click="searchData"
          >
            搜索
          </el-button>
          <el-button size="small" @click="reset">重置</el-button>
          <el-button
            type="primary"
            :disabled="canAdd()"
            size="small"
            @click="
              operateBtn(
                {
                  intevalValue: 1,
                },
                'create'
              )
            "
          >
            新增
          </el-button>
          <el-button
            type="primary"
            size="small"
            @click="startStop(true)"
          >
            启用
          </el-button>
          <el-button
            type="danger"
            size="small"
            @click="startStop(false)"
          >
            停用
          </el-button>
          <el-button
            type="danger"
            size="small"
            @click="deleteData({}, false)"
          >
            删除
          </el-button>
          <!-- <el-button size="small" @click="importListData">
            导入
          </el-button> -->
        </div>
      </div>
      <el-table
        border
        stripe
        :data="tableData"
        v-loading="tableLoading"
        :highlight-current-row="true"
        class="mt-20px"
        height="calc(100% - 104px)"
        ref="tableRef"
        :row-key="(record) => record.id"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          :reserve-selection="true"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column label="采集任务名称" prop="name" show-overflow-tooltip></el-table-column>
        <el-table-column label="入库栏目" prop="columnName" show-overflow-tooltip></el-table-column>
        <el-table-column label="是否启用" prop="isEnable" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isEnable"
              active-color="#0082ff"
              inactive-color="#ff4949"
              @change="switchChange($event, scope.row, false)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="采集周期" prop="intevalValue" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.intevalValue }}
            {{ scope.row.intevalType === 0 ? '小时' : scope.row.intevalType === 1 ? '天' : '周' }}
          </template>
        </el-table-column>
        <el-table-column label="上次采集时间" prop="lastSpider" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>
              {{
                scope.row.lastSpider !== null
                  ? dayjs(scope.row.lastSpider).format('YYYY-MM-DD HH:mm:ss')
                  : ''
              }}
            </div>
          </template></el-table-column
        >
        <el-table-column label="发布人" prop="creator" show-overflow-tooltip></el-table-column>
        <el-table-column
          label="发布时间"
          prop="creationTime"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="operateBtn(scope.row, 'look')"
            >
              查看
            </el-button>
            <el-button
              size="mini"
              @click="operateBtn(scope.row, 'update')"
            >
              编辑
            </el-button>
            <el-button
              size="mini"
              @click="deleteData(scope.row, true)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20px float-right"
        background
        @size-change="getList"
        @current-change="getList"
        :current-page.sync="page.pageNo"
        :page-size.sync="page.pageSize"
        :total="page.total"
        layout="sizes, total, prev, pager, next, jumper"
        :pager-count="5"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
      >
      </el-pagination>
    </el-card>
    <GathetTaskDig
      class="absolute top-0 left-0 z-100 h-full w-full"
      @close="closeGathetTaskDig"
      @success="getList"
      v-if="showGathetTaskDig"
      :treeData="treeData"
      :title="operateTitle"
      :mode="mode"
      :source="currentSource"
      :operateType="operateType"
      :detailData="detailData"
    ></GathetTaskDig>
    <!-- 导入start -->
    <!-- <wiz-upload-file
      v-dialogDrag
      v-if="importDialog"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
      @exportResults="exportResults"
    ></wiz-upload-file> -->
    <!-- 导入end -->
  </div>
</template>
<script>
import { SpiderConfigApi, ColumApi } from '@wiz-api/workbench'
import FnMixins from '@/assets/js/fnMixins'
import dayjs from 'dayjs'

const spiderConfigApi = new SpiderConfigApi()
const columApi = new ColumApi()

const GathetTaskDig = () => {
  return import('./GathetTaskDig')
}
export default {
  name: 'GatherTasksManagement',
  components: { GathetTaskDig },
  mixins: [FnMixins],
  data() {
    return {
      importDialog: false,
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 0, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '',
      },
      search: {
        name: '',
        isEnable: '',
      },
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      treeData: [],
      tableData: [],
      currentNode: false, // 记录当前选中节点是否为叶子节点
      treeKeyword: '',
      // 默认展开
      defaultExpandIds: [''],
      // 分类树显隐
      treeStandBy: true,
      mode: '',
      // 是否默认展开全部
      defaultExpandAll: false,
      treeLoading: false,
      tableLoading: false,
      currentNodeKey: '',
      selectedList: [],
      showGathetTaskDig: false,
      operateType: true,
      operateTitle: '',
      detailData: {},
      currentTreeId: '',
      currentSource: 0,
    }
  },
  created() {
    this.getList()
    this.getTreeData()
  },
  computed: {},
  methods: {
    canAdd() {
      if (this.currentNode) {
        return false
      }
      return true
    },
    importListData() {
      this.importDialog = true
      this.uploadFileProps.active = 0
      this.uploadFileProps.visible = true
    },
    searchData() {
      this.page.pageNo = 1
      this.getList()
      this.$refs.tableRef && this.$refs.tableRef.clearSelection()
    },
    reset() {
      this.search = this.$options.data().search
      this.searchData()
    },
    operateBtn(row, type) {
      this.detailData = row
      this.mode = type
      switch (type) {
        case 'create':
          this.operateTitle = `新增${row.columName ?? ''}栏目采集任务`
          this.operateType = true
          break
        case 'update':
          this.operateTitle = `编辑${row.columName ?? ''}栏目采集任务`
          this.operateType = true
          break
        case 'look':
          this.operateTitle = `${row.columName ?? ''}栏目采集任务详情`
          this.operateType = false
          break
        default:
          break
      }
      this.showGathetTaskDig = true
    },
    startGather() {},
    deleteData(row, type) {
      let ids = [] // 删除项的id集合
      if (!type) {
        // 删除勾选
        if (!this.selectedList.length) {
          this.$message.warning('请先勾选要删除的数据项')
          return
        }
        ids = _.map(this.selectedList, 'id')
      } else {
        ids = [row.id]
      }
      this.$confirm('是否确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err] = await spiderConfigApi.callDelete({ id: ids })
          if (!err) {
            this.$message.success('删除成功')
            this.$refs.tableRef && this.$refs.tableRef.clearSelection()
            this.searchData()
          }
        })
        .catch(() => {})
    },
    async getTreeData() {
      const [err, res] = await columApi.tree(0)
      if (!err) {
        this.treeData = res
      }
    },
    async getList() {
      const params = {
        body: {
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize,
          name: this.search.name,
          isEnable: this.search.isEnable !== '' ? this.search.isEnable : null,
          columnId: this.currentTreeId ? this.currentTreeId : null,
        },
      }
      this.tableLoading = true
      const [err, res] = await spiderConfigApi.page(params)
      if (!err) {
        this.tableData = res.items.map((it) => {
          it.creationTime = dayjs(it.creationTime).format('YYYY-MM-DD HH:mm:ss')
          return it
        })
        this.page.total = res.totalCount
      }
      this.tableLoading = false
    },
    // 收起、展开全部
    operateTree(bool) {
      this.defaultExpandIds = []
      this.treeStandBy = false
      this.defaultExpandAll = bool
      this.$nextTick(() => {
        this.treeStandBy = true
      })
    },
    // 自定义树过滤
    filterTree(value, data) {
      return data.name.includes(value)
    },
    handleNodeClick(node) {
      this.currentTreeId = node.id
      this.currentSource = node.source
      this.currentNode = node.isLeaf
      this.searchData()
    },
    handleSelectionChange(list) {
      this.selectedList = list
    },
    startStop(boolean) {
      if (!this.selectedList.length) {
        this.$message.warning('请先勾选要操作的数据')
        return
      }
      const ids = _.map(this.selectedList, 'id')
      this.switchChange(boolean, ids, true)
    },
    async switchChange(event, row, type) {
      const params = {
        isEnable: event,
        ids: [],
      }
      if (type) {
        params.ids = row
      } else {
        params.ids = [row.id]
      }
      const [err] = await spiderConfigApi.changeStatus({ body: params })
      if (!err) {
        this.$message.success('操作成功')
        this.getList()
        this.$refs.tableRef && this.$refs.tableRef.clearSelection()
      }
    },
    closeGathetTaskDig() {
      this.showGathetTaskDig = false
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append('input', value)
      })
      const [err, res] = await suppliesManagementApi.importFromExcelFile({
        input: formData.get('input'),
      })
      if (!err) {
        this.$message.success('导入成功')
        this.uploadFileProps.successCount = res.successCount
        this.uploadFileProps.failureCount = res.failureCount
        this.uploadFileProps.resultFile = res.resultFile
        this.uploadFileProps.active = 2
        this.searchData()
      }
      this.uploadFileProps.btnLoading = false
    },
    // 下载导入模板
    async exportTemplate() {
      // const [err, res] = await suppliesManagementApi.downLoadTemp()
      if (!err) {
        // this.downLoadExcel('采集任务管理模板', res, 'excel')
      }
    },
    async exportResults() {
      // const [err, res] = await fileApi.download(this.uploadFileProps.resultFile, {
      //   returnType: 'Blob',
      // })
      // if (!err) {
      //   this.downLoadExcel('采集任务管理导入结果', res, 'excel')
      // }
    },
  },
}
</script>
<style scoped lang="scss"></style>
